<template lang="pug">
.custom_dialog
  .dialog_container
    .dialog_close_btn(@click="closeClick")
      img(src="@/assets/img/icons/close.svg")
    .login_wrapper(v-if="layoutType == 0")
      h2.dialog_title 會員登入
      .dialog_content
        .input_wrapper
          input#account.dialog_input(
            v-model="email",
            name="account",
            placeholder="會員帳號"
          )
          label
            font-awesome-icon(:icon="['fas', 'user']")
        .input_wrapper
          input#password.dialog_input(
            v-model="password",
            type="password",
            name="password",
            placeholder="會員密碼"
          )
          label
            font-awesome-icon(:icon="['fas', 'key']")
        .dialog_btn(@click="loginBtnClick") 登入
      p.register_text 沒有帳號嗎？
        span(@click="toRegister") 註冊會員帳號
      p.forget_pwd_btn(@click="layoutType = 1") 忘記密碼
    .forget_pwd_wrapper(v-if="layoutType == 1")
      h2.dialog_title 忘記密碼
      .dialog_content
        p 請輸入您的會員帳號Email，
          br
          | 我們將發送重設密碼信函至您的信箱
        .input_wrapper
          input#account.dialog_input(
            v-model="sendEmail",
            name="sendEmail",
            placeholder="會員帳號 Email"
          )
          label
            font-awesome-icon(:icon="['fas', 'user']")
        .dialog_btn(@click="sendVerifyEmail") 發送重設密碼信函
      p.login_text 回到
        span(@click="layoutType = 0") 登入
  dialog-loading(v-if="loadingDialogShow", :content="loadingContent")
</template>

<script>
import { mapActions } from "vuex";
import { errorMessage } from "@/utils/message";
import { validEmail, validStringEmpty } from "@/utils/validate";
import DialogLoading from "@/components/dialog/DialogLoading";
import { resetPassword } from "@/api/user";

export default {
  name: "CustomDialogLogin",
  components: {
    "dialog-loading": DialogLoading,
  },
  data() {
    return {
      email: "",
      password: "",
      loadingDialogShow: false,
      loadingContent: "登入中....",
      layoutType: 0,
      sendEmail: "",
    };
  },
  methods: {
    ...mapActions("user", ["login"]),
    closeClick() {
      this.$emit("closeLoginDialog");
    },
    successBack() {},
    toRegister() {
      this.$router.push({ name: "Register" });
      this.closeClick();
    },
    loginBtnClick() {
      if (!validEmail(this.email)) {
        errorMessage(this, "帳號錯誤", "信箱格式錯誤");
        return;
      }

      if (validStringEmpty(this.password)) {
        errorMessage(this, "密碼錯誤", "密碼不可為空");
        return;
      }
      this.loadingDialogShow = true;
      this.login({ email: this.email, password: this.password })
        .then(() => {
          this.loadingDialogShow = false;
          this.$emit("successBack");
        })
        .catch(() => {
          this.loadingDialogShow = false;
          errorMessage(this, "登入失敗", "請確認帳號密碼");
        });
    },
    sendVerifyEmail() {
      if (!validEmail(this.sendEmail)) {
        errorMessage(this, "錯誤", "信箱格式錯誤");
        return;
      }
      this.loadingDialogShow = true;
      resetPassword({ email: this.sendEmail })
        .then(() => {
          this.loadingDialogShow = false;
          this.$emit("sendEmailSuccessBack");
        })
        .catch(() => {
          this.loadingDialogShow = false;
          errorMessage(this, "失敗", "請確認信箱是否正確");
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/dialog/dialog";

.input_wrapper {
  position: relative;
  margin-top: 30px;
}

label {
  position: absolute;
  font-size: 18px;
  top: 0;
  left: 24px;
  height: 100%;
  margin: 0;
  display: flex;
  align-items: center;
  color: $c-text;
}

.custom_dialog {
  input {
    padding-left: 50px;
    @include rect_radius(100%, 54px, white, 4px, $c-text, 1px);
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    outline: none;
    font-size: 16px;
  }

  .dialog_btn {
    @include rect_radius(100%, 54px, $c-text, 4px, $c-text, 0);
    margin-top: 30px;
    margin-left: auto;
    margin-right: auto;
    justify-content: center;
    cursor: pointer;
    text-align: center;
    line-height: 54px;
    font-size: 20px;
    color: $color_blue;

    &:hover {
      background-color: rgba($c-text, 0.9);
    }

    p {
      text-align: center;
      line-height: 62px;
    }

    img {
      margin-left: 9px;
    }
  }

  .register_text,
  .login_text {
    text-align: center;
    margin-top: 25px;

    span {
      color: $color_water_blue;
      cursor: pointer;
    }
  }

  .forget_pwd_btn {
    text-align: center;
    color: $color_water_blue;
    cursor: pointer;
  }
}

// RWD > extra small
@media (max-width: 575px) {
  .custom_dialog {
    .dialog_btn {
      width: 100%;
    }
  }
}
</style>
